import { ConvertableFromApi } from './ConvertableFromApi';

export class Budget extends ConvertableFromApi<Budget> {
    amount!: number;
    currentSpend!: number;
    timeGrain!: string;
    timePeriod: any;

    constructor(data?: any) {
        super(data);

        if(!this.objectFromApi || !this.objectFromApi.currentSpend){
            return;
        }
        this.amount = this.objectFromApi.amount;
        this.currentSpend = this.objectFromApi.currentSpend.amount;
        this.timeGrain = this.objectFromApi.timeGrain;
        this.timePeriod = this.objectFromApi.timePeriod;
    }

    createNew(element: any): Budget {
        return new Budget(element);
    }
}